import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthMonitor } from '../auth.monitor';
import { SharedModule } from '../shared.module';
import { BLSComponentModule } from '../bls/bls.component.module';
import { InstitutionComponentModule } from '../institution/institution.component.module';
import { MyProgressComponentModule } from '../user/myProgress/my-progress-component.module';
import { NCESComponent, NCESNearbyComponent } from './nces.component';
import { NCESLogoCoverComponent, NCESLogoCoverUpdateDialog} from './nces-logo-cover.component';

const ncesRoutes: Routes = [
	{ path: "School", component: NCESComponent, canActivate: [AuthMonitor], data: { authenticate: false, routeName: "NCES" } },
	{ path: "School/:schoolId", component: NCESComponent, canActivate: [AuthMonitor], data: { authenticate: false, routeName: "NCES" } },
	{ path: "", redirectTo: "/Search" }
];

@NgModule({
	imports: [
		SharedModule,
		BLSComponentModule,
		InstitutionComponentModule,
		MyProgressComponentModule,
		RouterModule.forChild(ncesRoutes)
	],
	declarations: [
		NCESComponent,
		NCESNearbyComponent,
		NCESLogoCoverComponent,
		NCESLogoCoverUpdateDialog
	],
	exports: []
})
export class NCESModule { }
